import { useEffect, useState } from "react";

const useScrollTopDetector = ({ offset = 0, buffer = 100 }) => {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    let previous = true;

    const handleScroll = () => {
      const y = window.scrollY;

      if (previous && y > offset + buffer) {
        setIsAtTop(false);
        previous = false;
      } else if (!previous && y < offset - buffer) {
        setIsAtTop(true);
        previous = true;
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [offset, buffer]);

  return isAtTop;
};

export default useScrollTopDetector;
